import axios from 'axios';
import {getItem} from '../utils/storage';
import { getApiDomain } from '../agent/config';
import getV2AxiosInstance from '../utils/v2Axios.js';

const version ="WA4.1"


export function setAvailabilityDetail(data){
    return {
        type: 'SET_AVAILABILITY_DETAIL',
        payload: data
    };
}

export function setMotivesList(data){
    return {
        type: 'SET_MOTIVES_LIST',
        payload: data
    };
}

export function setCallMotivesList(data){
  return {
    type: "SET_CALL_MOTIVES_LIST",
    payload: data
  }
}

export const modifyAvailablityDetail = (data) => {
    return {
        type: "MODIFY_AVAILABILITY_DETAIL",
        payload: data
    }
}

export const setCallAvailability = (data) => {
    return {
        type: "SET_CALL_AVAILABILITY",
        payload: {
          available: data
        }
    }
}

/**
 * returns response or error of api call
 * @param  {object} response [response of api call]
 * @return {object}          [response or error]
 */
function handleResponse(response){
  if(response.status==200){
    return response;
  }else{
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

/**
 * returns response or error of api call
 * @param  {array} responseArray [response of api call]
 * @return {array|object}          [response or error]
 */
function handleResponseMultiple(responseArray){
  let returnedResponse = [];
  responseArray.forEach((response) => {
    if(response.status==200){
      returnedResponse = [...returnedResponse, response];
    }else{
      let error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  });
  return returnedResponse;
}

/**
 * api call to get availability details
 */
export function getAvailabilityList(){
  return dispatch => {
    return getV2AxiosInstance()
    .post("/bridge/en/invoxapi/Agent", {
      action: "getAvailabilityDetail",
      params: { agent_id: localStorage.getItem("agent_id")
     },
    }).then(data => {
      if(data.data.response && data.data.response.items.length > 0){
      dispatch(setAvailabilityDetail(data.data.response.items))
      handleResponse(data);
      }
    });
  }
}

/**
 * api call to get availability details
 */
export function getAvailabilityDetail(){
  return getV2AxiosInstance()
  .post("/bridge/en/invoxapi/Agent", {
    action: "getAvailabilityDetail",
    params: { agent_id: localStorage.getItem("agent_id")
   },
  })
}

/**
 * api call to get motives list
 */
export function getMotivesList(){
  return getV2AxiosInstance()
  .post("/bridge/en/invoxapi/Client", {
    action: "listMotivesByClient",
    params: { agent_id: localStorage.getItem("agent_id")
   },
  })
}
/**
 * paralell api call to for getAvailabilityDetail and getMotivesList
 */
export function getAvailabilityAndMotives(){
  const requests = [getAvailabilityDetail(), getMotivesList()];
  return (dispatch) => {
    return axios.all(requests).then(
      axios.spread(function (availability, motivesList) {
        // dispatch(setAvailabilityDetail(availability.data.list_available));
        // dispatch(setMotivesList(motivesList.data.data));
        const allData = [
          availability.data.response.items,
          motivesList.data.response.items,
        ];
        dispatch(setCallMotivesList(allData));
        return handleResponse(availability);
      })
    );
  };
}
/**
 * change availability of service
 * @param  {object} payload contacts service_id and state_id
 * @return {object}         api response
 */

export function changeAvailability(payload){
  const params = {
    agent_id: localStorage.getItem("agent_id"),
    service_id: payload.service_id,
    state_id: payload.state_id,
  };

  if (payload.state_id == 2) {
    params.motive_id = payload.motive_id;
  }

  return getV2AxiosInstance().post("/bridge/en/invoxapi/Agent", {
    action: "changeAvailability",
    params: params,
  });
}

export function changeAgentAvailability(payload){
     return getV2AxiosInstance()
   .post("/bridge/en/invoxapi/Agent", {
    action: "changeAgentAvailability",
    params: { agent_id: localStorage.getItem("agent_id"),
    status_data : JSON.stringify(payload)
   }
  })
}

export function changeDefaultAvailability(state){
  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "changeAvailability",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          state_id: state,
        },
      })
      .then(handleResponse);
  };
}


export function setOnline(){
  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "setOnline",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          origin: version
        },
      })
      .then(handleResponse);
  };
}

/**
 * changes availability of multiple services
 * @param  {array} payload
 * @return {function}
 */
export function changeAvailabilityMultiple(payload){
  return dispatch => {
    const allRequests = [changeAgentAvailability(payload)];
    return axios.all(allRequests)
    .then(axios.spread((...availability) => {
      return handleResponseMultiple(availability);
    }))
  }
}



// WEBPACK FOOTER //
// ./src/actions/availability.js